import { useContext } from 'react';

import { BookmarkedRecipesContext } from './BookmarkedRecipesProvider';

const useBookmarkedRecipes = () => {
  const {
    bookmarkedRecipes,
    loadBookmarkedRecipes,
    bookmarksFirstLoadStatus,
  } = useContext(BookmarkedRecipesContext);

  return { bookmarkedRecipes, loadBookmarkedRecipes, bookmarksFirstLoadStatus };
};

export default useBookmarkedRecipes;
